import { render } from "./LocalizedDropdown.vue?vue&type=template&id=1a2d7746&scoped=true"
import script from "./LocalizedDropdown.vue?vue&type=script&lang=js"
export * from "./LocalizedDropdown.vue?vue&type=script&lang=js"

import "./LocalizedDropdown.vue?vue&type=style&index=0&id=1a2d7746&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2d7746"]])

export default __exports__